import { render } from "./allsuppliers.vue?vue&type=template&id=2d29a057&scoped=true"
import script from "./allsuppliers.vue?vue&type=script&lang=js"
export * from "./allsuppliers.vue?vue&type=script&lang=js"

import "./allsuppliers.vue?vue&type=style&index=0&id=2d29a057&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d29a057"]])

export default __exports__